import React from "react"
import ReactJWPlayer from "react-jw-player"

import { getViewport } from "utils"

import Icon from "icons"
import { Modal, Content, TopRow } from "./styles"

const PopupVideo = ({ videoId, onPercentViewed = () => null, onCloseModal }) => (
  <Modal onClose={onCloseModal} label="Video">
    <Content>
      <TopRow>
        <button type="button" onClick={onCloseModal}>
          <Icon id="close-icon" width={25} height={25} title="Close" />
        </button>
      </TopRow>
      <ReactJWPlayer
        playerId="mbg-jw-player"
        playerScript={process.env.GATSBY_JW_PLAYER_SCRIPT}
        file={videoId}
        onReady={() => {
          if (getViewport() !== "mobile") {
            return
          }

          window.jwplayer("mbg-jw-player").setFullscreen(true)
          window
            .jwplayer("mbg-jw-player")
            .getContainer()
            .querySelector("video")
            .removeAttribute("playsinline")
        }}
        onExitFullScreen={() => setTimeout(onCloseModal, 10)}
        isAutoPlay
        onTwentyFivePercent={() => onPercentViewed(25)}
        onFiftyPercent={() => onPercentViewed(50)}
        onSeventyFivePercent={() => onPercentViewed(75)}
        onOneHundredPercent={() => onPercentViewed(100)}
      />
    </Content>
  </Modal>
)

export default PopupVideo
